import React from 'react';
import { Img, Neon } from '../../components';
import { Content, Description, FeaturedImg, Wrapper } from './Bio.styled';

export default function Bio({ data }) {
	const { title, description } = data.site.siteMetadata;
	return (
		<Wrapper>
			<Neon as="h1">About</Neon>
			<Content>
				<Description>{description}</Description>
				<FeaturedImg>
					<Img
						src={data.file.childImageSharp.gatsbyImageData}
						alt={title}
					/>
					<div className="overlay"></div>
				</FeaturedImg>
			</Content>
		</Wrapper>
	);
}
